import { DOCUMENT } from "@angular/common";
import {
  Component,
  CSP_NONCE,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SubscriptionLike as ISubscription } from "rxjs";

import { MatDialog } from "@angular/material/dialog";
import { adpModalComponent, ConfigService, LocalResourcesManagerService } from "common";
import { ButtonAction, ModalData, Notification, NotificationService } from "digital-core";
import { DynamicScriptLoaderService } from "common/services/dynamic-script-loader.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit, OnDestroy {
  public firstName: string;
  public lastName: string;
  public isAuthenicated: Boolean = false;
  public endDateTime: string;

  public blockUI: Boolean;

  public currentRoute: string;
  public title: string;
  public version: string;
  public webApiEndPoint: string;
  public imagesDirectory: string;
  notificationSubscriptor: ISubscription;
  bsModalRef: BsModalRef;
nonce: string | null;
  constructor(
    private elementRef: ElementRef,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private localResourcesManagerService: LocalResourcesManagerService,
    private notificationService: NotificationService,
    private modalService: BsModalService,
    private configService: ConfigService,
    private renderer2: Renderer2,
    private matDialog: MatDialog,
    @Inject(DOCUMENT) private _document,
    @Inject(CSP_NONCE) nonce: string | null,
   private dynamicScriptLoaderService: DynamicScriptLoaderService) {
         this.nonce=nonce;
    const native = this.elementRef.nativeElement;

    this.webApiEndPoint = native.getAttribute("webApiEndPoint");
    this.imagesDirectory = native.getAttribute("imagesDirectory");
    this.localResourcesManagerService.setCurrentAssetsParentPath(
      this.imagesDirectory
    );
    this.registerIcons();
    //this.setupGTM();
  }


  ngOnInit() {
    this.loadScripts();
    this.notificationSubscriptor = this.notificationService
      .getNotificationObservable()
      .subscribe(newNotification => {
        if (newNotification.isError) {
          this.showError(newNotification);
        } else {
          this.showInfo(newNotification);
        }
      });
 
    }

  

  ngOnDestroy() {
    this.notificationSubscriptor.unsubscribe();
  }

  showError(error: Notification) {
    let modalData = new ModalData();
    modalData.Header = "Error";
    modalData.Body = error.Message;
    modalData.ControlArray = [
      new ButtonAction("Close", "Close")
    ];

    let dialogRef = this.matDialog.open(adpModalComponent, { data: modalData });
    this.dialogRefClosed(dialogRef);
  }

  showInfo(info: Notification) {
    let modalData = new ModalData();
    modalData.Header = "Information";
    modalData.Body = info.Message;
    modalData.ControlArray = [
      new ButtonAction("Close", "Close")
    ];

    let dialogRef = this.matDialog.open(adpModalComponent, { data: modalData });
    this.dialogRefClosed(dialogRef);
  }

  dialogRefClosed(dialogRef: any)
  {
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.toLowerCase() === "yes") {
        window.scroll(0, 0);
      }
    });
  }

  public registerIcons() {
    this.matIconRegistry.addSvgIcon(
      "dashboard",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/dashboard.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "sales",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/sales.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "reports",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/reports.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "users",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/users.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "customers",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/customers.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "training",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/training.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "logout",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/logout.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "claim",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/claim.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "complain",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/complain.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "close",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/close.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "edit",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/edit.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "device",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/device.svg`
      )
    );

    this.matIconRegistry.addSvgIcon(
      "error-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/error-icon.svg`
      )
    );
    this.matIconRegistry.addSvgIcon(
      "mobile-device",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/MobileDevices.svg`
      )
    );
    this.matIconRegistry.addSvgIcon(
      "gadgets",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `${this.imagesDirectory}/svg/Gadgets.svg`
      )
    );
  }

  public setupGTM() {
    const script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.configService.gtmId}`;
    this.renderer2.appendChild(this._document.body, script);
  }

  loadScripts() {
    if(this.configService._config.keys.GoogleApiKey){
    this.dynamicScriptLoaderService
      .loadScript(
        'google-maps-api',
        '',
        this.configService._config.keys.GoogleApiKey,
        this.nonce
      )
      .then((data) => true);
  }
}
}
